// extracted by mini-css-extract-plugin
export default {"btnSignIn":"SignIn_btnSignIn__Fb7FI"};